import { ReactNode } from 'react'

import classNames from 'classnames'

import {
  CommonBarCodeIcon,
  CommonHistoryIcon,
  CommonBookingIcon,
  CommonOrderIcon,
  CommonClose5RoundIcon,
  CommonMapIcon,
  CommonEdit2Icon,
  CommonQRIcon,
  BriefingRefreshIcon,
  CommonTel2Icon,
  CommonWrite3Icon,
  CommonTrainIcon,
} from '@local/assets/icons'

import { ClickEvent } from '@web/types'
import Clickable from '@web/ui/components/Clickable'

import styles from './FunctionButton.module.scss'

export type FunctionButtonTypes =
  | 'HISTORY'
  | 'ORDER_HISTORY'
  | 'RESERVATION_HISTORY'
  | 'RESERVATION'
  | 'ORDER'
  | 'BARCODE'
  | 'QRCODE'
  | 'LOCATION'
  | 'EDIT'
  | 'CANCEL'
  | 'REFRESH'
  | 'CALL'
  | 'REVIEW_WRITE'
  | 'TRAIN'
  | 'TEXT_ONLY'

interface FunctionButtonProps {
  type?: FunctionButtonTypes
  title?: string
  hideButtonName?: boolean
  buttonClassName?: string
  iconClassName?: string
  onClick?: (e: ClickEvent) => void
  clickCode?: string
  href?: string
  icon?: ReactNode
  disabled?: boolean
}

const functionIconMap = {
  HISTORY: { name: '예매 내역', icon: CommonHistoryIcon },
  ORDER_HISTORY: { name: '주문 내역', icon: CommonHistoryIcon },
  RESERVATION_HISTORY: { name: '예약 내역', icon: CommonHistoryIcon },
  RESERVATION: { name: '다시 예약', icon: CommonBookingIcon },
  ORDER: { name: '다시 주문', icon: CommonOrderIcon },
  BARCODE: { name: '바코드', icon: CommonBarCodeIcon },
  QRCODE: { name: 'QR코드', icon: CommonQRIcon },
  LOCATION: { name: '길찾기', icon: CommonMapIcon },
  EDIT: { name: '예약수정', icon: CommonEdit2Icon },
  CANCEL: { name: '예약취소', icon: CommonClose5RoundIcon },
  REFRESH: { name: '새로고침', icon: BriefingRefreshIcon },
  CALL: { name: '전화', icon: CommonTel2Icon },
  REVIEW_WRITE: { name: '리뷰 쓰기', icon: CommonWrite3Icon },
  TRAIN: { name: '기차 예매', icon: CommonTrainIcon },
  TEXT_ONLY: null,
}

export default function FunctionButton({
  type,
  title,
  hideButtonName,
  onClick,
  clickCode,
  buttonClassName,
  iconClassName,
  href,
  icon,
  disabled,
}: FunctionButtonProps) {
  const functionIcon = type ? functionIconMap[type] : null
  const Icon = icon || functionIcon?.icon
  const name = functionIcon?.name

  return (
    <Clickable
      className={classNames(styles.btn, { [styles.type_hide_name]: hideButtonName }, buttonClassName)}
      onClick={onClick}
      nClickCode={clickCode}
      href={href}
      aria-disabled={disabled}
      disabled={disabled}
    >
      {Icon && <Icon className={classNames(styles.icon, iconClassName)} aria-hidden="true" />}
      <span className={classNames(styles.name, { place_blind: hideButtonName })}>{title || name}</span>
    </Clickable>
  )
}
